  <nz-table #tabela
    class="table-custom-border-none"
    nzSize="small"
    [nzData]="dataSet?.content"
    [nzShowPagination]="true"
    [nzFrontPagination]="false"
    [nzShowTotal]="rangeTemplate"
    [nzNoResult]="empty"
    nzShowSizeChanger
    [nzLoading]="loadingTabela"
    [nzTotal]="dataSet?.totalElements"
    [(nzPageIndex)]="pageIndex"
    [(nzPageSize)]="pageSize"
    (nzPageIndexChange)="buscarDados()"
    (nzPageSizeChange)="buscarDados(true)">
  <thead>
    <tr class="table-theme-bg-color thead-primary-color">
      <th *ngFor="let coluna of colunas">
        {{ coluna }}
      </th>
    </tr>
  </thead>
  <tbody class="bg-section">
    <tr *ngFor="let data of dataSet?.content">
      <td *ngFor="let key of columnKeys">
        <ng-container *ngIf="!isObject(data[key]); else objectValue">
          <ng-container *ngIf="isBoolean(data[key]); else notBoolean">
            <div *ngIf="data[key]">Ativo</div>
            <div *ngIf="!data[key]">Inativo</div>
          </ng-container>
          <ng-template #notBoolean>
            <div *ngIf="isDataCadastro(data[key], key)">
              {{ data[key]}}
              <!-- {{ data[key] | date: 'dd/MM/yyyy' }} -->
            </div>
            <div *ngIf="!isDataCadastro(data[key], key)"  class="limitText">
              <ng-container *ngIf="key === 'numeroCena'">
                {{ data['numeroCena'] + data['complementoCena'] }}
              </ng-container>
              <ng-container *ngIf="key !== 'numeroCena'">
                {{ data[key] }} 
              </ng-container>
            </div>
          </ng-template>
        </ng-container>
        <ng-template #objectValue>
          <div [ngSwitch]="key">
            <ng-container *ngSwitchCase="'status'">
              <div *ngIf="data[key]?.descricao" class="fw-bold" [ngClass]="colorFn(data[key].descricao)">
                {{ data[key].descricao }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'equipe'">
              <div *ngIf="data[key]?.equipeNome">
                {{ data[key].equipeNome }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'capitulo'">
              <div *ngIf="data[key]?.numeroCapitulo">
                {{ data[key].numeroCapitulo }}
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'cenario'">
              <div *ngIf="data[key]?.descricao">
                {{ data[key].descricao }}
              </div>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <div *ngIf="data[key]?.descricao">
                {{ data[key].descricao }}
              </div>
              <div *ngIf="data[key]?.nome">
                {{ data[key].nome }}
              </div>
            </ng-container>
          </div>
        </ng-template>
      </td>
      <td>
        <ng-container *ngIf="!esconderEditar">
          <button nz-button nzType="text" nzSize="small" nz-popover nzPopoverContent="Editar" nzPopoverPlacement="topRight" (click)="edit(data.id)">
            <span class="fs-4 mx-2 tabler--edit"></span>
          </button>
        </ng-container>
        <ng-container *ngIf="isAtivarInativarDeletarBtn(data)">
          <button nz-button nzType="text" nzSize="small" nz-popover [nzPopoverContent]="textoAtivarInativarDeletarBtn(data)" nzPopoverPlacement="topRight" (click)="acaoAtivarInativarDeletarBtn(data)">
            <span class="fs-4 mx-2" [ngClass]="iconeAtivarInativarDeletarBtn(data)"></span>
          </button>
        </ng-container>
      </td>
    </tr>
  </tbody>
  </nz-table>
  <ng-template #rangeTemplate let-range="range">
    Visualizando {{ range[1] }} de {{ dataSet?.totalElements }} resultados
  </ng-template>
  <ng-template #empty>
  <!-- <nz-empty [nzNotFoundContent]="'Nenhum resultado encontrado'"></nz-empty> -->
  </ng-template>
  <ng-template #footerTabela>
  <div class="d-flex justify-content-end align-items-center">
    <div class="me-4" *ngIf="dataSet?.totalElements">
      <span><strong>{{ dataSet?.totalElements }}</strong></span>
    </div>
  </div>
  </ng-template>
